export function parseLobbyFinishEvent(event: any) {
    return {
        bgDeduction: Number(event.returnValues.bgDeduction),
        bulletsDeduction: Number(event.returnValues.bulletsDeduction),
        carDamage: Number(event.returnValues.carDamage),
        cashDeduction: Number(event.returnValues.cashDeduction),
        failureType: Number(event.returnValues.failureType),
        isSuccess: Boolean(event.returnValues.isSuccess),
        lobbyId: Number(event.returnValues.lobbyId),
        newBodyguardCategoryId: Number(event.returnValues.newBodyguardCategoryId),
        newBodyguardItemId: Number(event.returnValues.newBodyguardItemId),
        newBodyguardTypeId: Number(event.returnValues.newBodyguardTypeId),
        rewardCount: Number(event.returnValues.rewardCount),
        rewardSizePercents: event.returnValues.rewardSizePercents.map((percent: number) => Number(percent)),
        rewardTypeIds: event.returnValues.rewardTypeIds.map((typeId: number) => Number(typeId)),
        successChance: Number(event.returnValues.successChance),
        timestamp: Number(event.returnValues.timestamp),
        healthDeductionPoint: Number(event.returnValues.healthDeductionPoint),
    }
}